import { render, staticRenderFns } from "./ServicesCompaniesListView.vue?vue&type=template&id=2c0e912b&"
import script from "./ServicesCompaniesListView.vue?vue&type=script&lang=ts&"
export * from "./ServicesCompaniesListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports